import { formatOptionalField } from './format-optional-field';

import type { ApplicationData, PartnerApplicationContext } from '../../model';

export function formatHeadOfficeAddress(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['headOfficeAddress']
): ApplicationData {
  if (!values) return data;

  return {
    ...data,
    headOfficeAddress: {
      country: values.country,
      region: values.region,
      province: values.province,
      cityOrMunicipality: values.cityOrMunicipality,
      postalCode: values.postalCode,
      barangay: values.barangay,
      streetAndHouse: values.streetAndHouse,
      unitAndFloor: formatOptionalField(values.unitAndFloor),
    },
  };
}
